import * as React                from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import DV                                     from 'ts-data-validator';

import './completed-project.style.scss';

import { staticPageConstants } from '../../../common/constants/staticPageConstants';

import ConsultationBlock       from '../../components/consultationBlock';
import Preloader               from '../../components/containers/preloader';
import Meta                    from '../../components/meta';
import PageHeader              from '../../components/pageHeader';
import { useCommon }           from '../../providers/common';
import { useCompletedProject } from '../../providers/completed-project';
import { useModal }            from '../../providers/modal';

import renderStaticSection from '../_common/utils/renderStaticSection';
import Notfound            from '../notfound/components/Notfound';

import { CompletedProjectItem } from './components';
import CompletedProjectModal    from './components/modal';

const CompletedProject: React.FC = function() {
  const history = useHistory();
  const location = useLocation();
  const params  = useParams<{ page?: string }>();

  const completedProjects: any      = useCompletedProject();
  const common: Record<string, any> = useCommon();
  const modal: any                  = useModal();

  const page        = React.useMemo(() => {
    return common.pages.find((page: any) => {
      return page.urlKey === params.page;
    });
  }, [common.pages, params.page]);
  const content     = React.useMemo(() => {
    if (!page) {
      return;
    }

    try {
      return JSON.parse(page.content);
    } catch {
      return void 0;
    }
  }, [page]);
  const headerProps = React.useMemo(() => {
    if (!DV.isString(page.headImage)) {
      return {
        transparent: false,
      };
    }

    return {
      transparent: true,
      bg:          page.headImage,
    };
  }, [page.headImage]);

  const handleOpen = React.useCallback((props: any) => {
    modal.showModal(
      '',
      {
        component: CompletedProjectModal,
        props:     {
          ...props,
          onClose() {
            history.replace(`/${page.urlKey}`);
          },
        },
      },
      true,
    );
  }, [page]);

  React.useEffect(() => {

    const params    = new URLSearchParams(location.search);

    const id = params.get('id');

    if (id) {
      const item = completedProjects.items.find((project: any) => {
        return project.id === Number(id);
      })

      if (item) {
        handleOpen(item);
      }
    }
  }, [location.search])

  if (!page) {
    return <Notfound />;
  }

  return (
    <>
      <div className={'page-content'}>
        <Meta {...page.meta} />
        {DV.isNotEmptyString(page.label) && <PageHeader {...headerProps}>{page.label}</PageHeader>}
        <main className={page.template}>
          <section className={'body'}>
            <div className={'container'}>
              <div className={'items_container'}>
                {completedProjects.items.map((completedProject: any) => {
                  return (
                    <CompletedProjectItem
                      key={completedProject.id}
                      {...completedProject}
                    />
                  );
                })}
              </div>
            </div>
          </section>
          {content?.PAGE_TYPE === staticPageConstants.PAGE_TYPE.STATIC_PAGE && (
            <section className={'description'}>
              {content.SECTIONS.map((section: any, index: number) => renderStaticSection(section, index))}
            </section>
          )}
        </main>
        <ConsultationBlock maxWidth={'1212px'} />
      </div>
      {completedProjects.loading && <Preloader />}
    </>
  );
};

export default CompletedProject;